import React, { useEffect, useState, useContext, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import openSocket from 'socket.io-client'

// Components
import PrimaryButton from '../../components/atoms/PrimaryButton'
import Invoice from '../../components/molecules/Invoice'
import Loader from '../../components/molecules/Loader'

// Context
import CommonContext from '../../context/common/commonContext'
import AlertContext from '../../context/alert/alertContext'
import AuthContext from '../../context/auth/authContext'

// Common Function
import { apiCall } from '../../common/api'
import { handleRedirectInternal } from '../../common/components'

const BuynowConfirm = (props) => {
    const history = useHistory()
    const { phrase } = useContext(CommonContext)
    const { setAlert } = useContext(AlertContext)
    const { user } = useContext(AuthContext)

    // state
    const [invoiceData, setInvoiceData] = useState({})
    const [invoiceLoading, setInvoiceLoading] = useState(true)
    const [invoiceLoadError, setInvoiceLoadError] = useState(false)
    const [isConfirming, setIsConfirming] = useState(false)

    const invoiceDataRef = useRef(invoiceData)
    const userRef = useRef(user)

    const socketHandler = (data) => {
        if (data.id == invoiceDataRef.current.id) {
            if (data.bpop_cbidder == userRef.current?.id) {
                if (data.status == 'success') {
                    setAlert(phrase.order_completed, 'success')
                    handleRedirectInternal(history, `invoice/${data.invoiceid}`)
                } else {
                    setAlert(data.error, 'error')
                }
            } else {
                setAlert(phrase.this_item_is_out_of_stock, 'error')
            }
        }
    }
    useEffect(() => {
        if (props.match.params.id) {
            getInvoiceData(props.match.params.id)
        } else {
            setInvoiceLoading(false)
            setInvoiceLoadError(true)
        }
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`)
        socket.on('buynowAddtime', (data) => {
            socketHandler(data)
        })

        return () => {
            socket.off('buynowAddtime', (data) => {
                socketHandler(data)
            })
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        invoiceDataRef.current = invoiceData
        userRef.current = user
    })

    // Get Invoice Data
    const getInvoiceData = async (id) => {
        setInvoiceLoading(true)
        setInvoiceLoadError(false)
        const results = await apiCall('get', `viewsample/${id}`, '', '', 'product')
        const data = results?.data || results?.response?.data

        if (data?.status == 'success' && data?.data?.invoicedata) {
            // convert bprice to amount
            data.data.invoicedata.amount = data.data.invoicedata.bprice
            setInvoiceData(data.data.invoicedata)
            setInvoiceLoading(false)
            return
        }

        setInvoiceData({})
        setInvoiceLoading(false)
        setInvoiceLoadError(true)
        setAlert(data?.message || data?.error || phrase.something_went_wrong, 'error')
    }

    // Confirm Order
    const confirmOrder = async () => {
        if (isConfirming) return
        if (!invoiceData?.id || !invoiceData?.bprice) {
            setAlert(phrase.something_went_wrong, 'error')
            return
        }

        setIsConfirming(true)
        let data = {
            id: invoiceData.id,
            buyprice: invoiceData.bprice,
        }
        const response = await apiCall('post', 'buynowConfirm', data, '', 'product')
        const responseData = response?.data || response?.response?.data

        if (responseData?.status == 'error' || response?.response?.status >= 400) {
            setAlert(
                responseData?.message || responseData?.error || phrase.something_went_wrong,
                'error',
            )
        }
        setIsConfirming(false)
    }

    if (invoiceLoading) {
        return <Loader />
    }

    if (invoiceLoadError || Object.keys(invoiceData).length === 0) {
        return (
            <div className="container py-5 text-center">
                <h5>{phrase.something_went_wrong}</h5>
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ gap: '10px' }}
                >
                    <PrimaryButton label={phrase.back} onClick={() => history.goBack()} />
                    <PrimaryButton
                        label={phrase.back_to_search || 'Back to Search'}
                        onClick={() => handleRedirectInternal(history, 'search')}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            <Invoice data={invoiceData} buynowConfirm={true} />
            <div
                className=" d-flex justify-content-center align-items-start mb-5"
                style={{ backgroundColor: 'white', padding: '10px' }}
            >
                <div className="mr-1">
                    <PrimaryButton label={phrase.cancel} onClick={() => history.goBack()} />
                </div>

                <div>
                    <PrimaryButton
                        onClick={() => confirmOrder()}
                        label={
                            isConfirming
                                ? phrase.processing || 'Processing...'
                                : phrase.confirm_your_order
                        }
                        disabled={isConfirming}
                    />
                </div>
            </div>
        </>
    )
}

export default BuynowConfirm
